<template>
  <div class="avecor-table" >
    <v-toolbar style=""  flat color="white">
      <v-toolbar-title >Tilaukset</v-toolbar-title>
      <v-col cols="2">
        <div v-if="orderFilter === 'yearMonthInvoiced'">
          <div style="font-size:9px;display:inline-block;width:100px" class="pr-2">
            <div>Katteet laskettu {{numberOfInvoicedOpsMarginCalculatedInSelectedMonth}}</div>
            <div>Kaikki tuotteet {{numberOfInvoicedOpsInSelectedMonth}}</div>
          </div>
          <div style="font-size:11px;display:inline-block;width:100px" class="pr-2">
            <div>Laskennan status</div>
            <div>
              <span v-if="numberOfInvoicedOpsMarginCalculatedInSelectedMonth && numberOfInvoicedOpsInSelectedMonth">{{((numberOfInvoicedOpsMarginCalculatedInSelectedMonth / numberOfInvoicedOpsInSelectedMonth) * 100).toFixed(2)}}%</span>
              <span v-else>0</span>
            </div>
          
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <v-text-field
          v-if="orderFilter === 'yearMonthInvoiced' || orderFilter === 'invoiced'"
          :value="marginsSearchInvoiced"
          ref="ordersSearch"
          class="table-search avecor-no-underline"
          label="Haku"
          @change="(event) => marginsSearchInvoiced = event"
          single-line
          hide-details
          autocomplete="off"
        ></v-text-field>
        <v-text-field
          v-else
          :value="marginsSearch"
          ref="ordersSearch"
          class="table-search avecor-no-underline"
          label="Haku"
          @change="(event) => marginsSearch = event"
          single-line
          hide-details
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="5" class="text-right">
        <v-btn v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'" @click.stop="exportMonthMargins()" color="#000000" dark class="avecor-button-global add-button mb-2 mr-3 mt-2" >Export katteet</v-btn>
        <select v-if="orderFilter === 'yearMonthInvoiced'" v-model="selectedYearMonthForInvoiced" class="status-select mr-4 pr-1" style="height:27px;" >
          <option value="all">Kaikki</option>
          <option v-for="(item) in getYearMonthOptionsForInvoiced" :value="item">{{item}}</option>
        </select>
        <v-btn-toggle  :multiple="false" :mandatory="true" style="border:1px #ccc solid; margin-right:20px;" v-model="orderFilter">
          <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="yearMonthInvoiced">
            Laskutetut kuukausittain
          </v-btn>
          <!-- <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="invoiced">
            Kaikki laskutetut
          </v-btn> -->
          <v-btn v-if="allAccess" height="30" class="avecor-button-global avecor-button-group-button" value="lessThanTwoMonthsInvoicesAllPaid">
            Alle 2 kk vanhat maksetut
          </v-btn>
          <!-- <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="invoicesAllPaid">
            Kaikki maksetut
          </v-btn> -->
          <v-btn v-if="allAccess" height="30" class="avecor-button-global avecor-button-group-button" value="lessThanTwoMonths">
            All 2 kk vanhat tilaukset
          </v-btn>
          <v-btn v-if="allAccess" height="30" class="avecor-button-global avecor-button-group-button" value="allOrders">
            Kaikki tilaukset
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-toolbar>
    <OrderExpand location="margins" v-if="selectedOrderId ? true: false" />
    <div v-if="orderFilter === 'lessThanTwoMonthsInvoicesAllPaid' || orderFilter === 'invoicesAllPaid' || orderFilter === 'lessThanTwoMonths' || orderFilter === 'allOrders'">
      <v-row no-gutters class="order-margins-headers" id="order-margins-headers" style="background:#EEEEEE;">
        <v-col cols="6">
          <v-row no-gutters>
              <v-col sm="1" class="orders-custom-header pr-1"></v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Tilauspäivä</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Maksettu pvm</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Netvisor id</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Myyjä</v-col>
              <v-col sm="2" class="orders-custom-header pr-1">Yritys</v-col>
              <!-- <v-col sm="2" class="orders-custom-header pr-1">Y-tunnus</v-col> -->
              <v-col sm="3" class="orders-custom-header pr-1">Tilauskooste</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Toimituskulut</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Yhteensä</v-col>
          </v-row>  
        </v-col>
        <v-col cols="6">
          <v-row no-gutters>
            <v-col sm="3" class="orders-custom-header pr-1">Myyjän Kommentti</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Myyjän Kate</v-col>
            <v-col sm="3" class="orders-custom-header pr-1" v-if="staff[user.uid] !== undefined && (staff[user.uid].role == 'admin' || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')">Toimiston Kommentti</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Toimiston Kate</v-col>
            <v-col sm="3" class="orders-custom-header pr-1">Toimiston Katekommentti</v-col>
            <v-col sm="1" class="orders-custom-header pr-5 text-right">Status</v-col>
          </v-row>  
        </v-col>
        
      </v-row>
        
      <div class="order-margins-content" id="order-margins-content"  >
        <v-lazy
          style="width:100%; padding:0px; margin:0px;min-height:30px"
          :options="{
            threshold: .1
          }"
          v-for="(order, index) in getOrders"
          :key="order.id"
        >
          <v-row no-gutters  class="order-margins-row">
            <v-col cols="6">
              <v-row no-gutters>
                <v-col sm="1" class="pr-1 text-center">
                    <v-icon :size="12" style="padding-right:3px;" @click="selectedOrderId = order.id;">
                      far fa-eye
                    </v-icon>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <span class="orders-custom-field" style="color:rgba(0,0,0,.38);" >{{ order.created_at ? customFormatter(order.created_at) : '' }}</span>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <span class="orders-custom-field" style="color:rgba(0,0,0,.38);" >{{ order.invoicesPaidDate ? customFormatter(order.invoicesPaidDate) : '' }}</span>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-text-field :value="order.netvisorId" @change="v => inlineSaveField(order.id,'netvisorId',v)"  hide-details class="avecor-select"></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(order.firstName)" style="color:rgba(0,0,0,.38);">{{staff[order.salespersonId].firstName}}</div>
                </v-col>
                <v-col sm="2" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(companies[order.companyId].companyName)" style="color:rgba(0,0,0,.38);">{{companies[order.companyId].companyName}}</div>
                </v-col>
                <v-col sm="3" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(order.orderSummary)" style="color:rgba(0,0,0,.38);">{{order.orderSummary}}</div>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-text-field
                    slot="input"
                    :value="order.deliveryCharge + '€'"
                    class="avecor-select"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <div class="orders-custom-field" 
                    @click="copyToClipboard((Number(order.total) + Number(order.deliveryCharge)).toFixed(2))" 
                    style="color:rgba(0,0,0,.38);">
                    {{(Number(order.total) + Number(order.deliveryCharge)).toFixed(2) + '€'}}
                  </div>
                  <!-- <v-text-field
                    slot="input"
                    :value="getTotal(order.id) + '€'"
                    single-line
                    class="avecor-select"
                    disabled
                  ></v-text-field> -->
                </v-col>
              </v-row>  
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col sm="3" class="pr-1">
                  <div class="orders-custom-field" 
                    @click="copyToClipboard(orders[order.id].orderComments)" 
                    style="color:rgba(0,0,0,.38);">
                    {{orders[order.id].orderComments}}
                  </div>
                  <!-- <v-textarea
                    :value="order.orderComments"
                    @change="v => inlineSaveField(order.id,'orderComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select"
                  ></v-textarea> -->
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-text-field
                    :value="orders[order.id].salespersonMargin"
                    @change="v => inlineSaveField(order.id,'salespersonMargin',v)"
                    single-line
                    class="avecor-select"
                  ></v-text-field>
                </v-col>
                <v-col sm="3" class="pr-1" v-if="staff[user.uid] !== undefined && (staff[user.uid].role == 'admin' || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')">
                  <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" max-width="500" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >
                        <div v-if="orders[order.id].officeOrderComments" class="orders-custom-field" >{{orders[order.id].officeOrderComments.substring(0,100)+'...'}}</div>
                      </span>
                    </template>
                    <div style="font-size:11px;background:#FFF;">
                      <div style="padding:10px;background:#FFF;">
                      <pre><span style="font-family:Roboto, sans-serif;text-wrap:wrap;">{{orders[order.id].officeOrderComments}}</span></pre>
                      </div>
                    </div>
                  </v-menu>
                  <!-- <v-textarea
                    :disabled="!allAccess"
                    :value="orders[order.id].officeOrderComments"
                    @change="v => inlineSaveField(order.id,'officeOrderComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select"
                  ></v-textarea> -->
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-text-field
                    :disabled="!allAccess"
                    :value="orders[order.id].officeMargin"
                    @change="v => inlineSaveField(order.id,'officeMargin',v)"
                    single-line
                    class="avecor-select"
                  ></v-text-field>
                </v-col>
                <!--<v-flex xs12 sm8 md2 pr-1 v-if="staff[user.uid].role == 'admin' || staff[user.uid].role == 'office'">-->
                <v-col sm="3" class="pr-1">
                  <v-textarea
                    :disabled="!allAccess"
                    :value="orders[order.id].officeOrderMarginComments"
                    @change="v => inlineSaveField(order.id,'officeOrderMarginComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select"
                  ></v-textarea>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-row no-gutters>
                    <v-col cols="10" class="pr-2 text-right">
                      <div v-if="ordersData[order.id] !== undefined && ordersData[order.id].orderedProducts !== undefined">
                        <div v-for="(opKey, index) in Object.keys(ordersData[order.id].orderedProducts)" :key="'op-status-'+opKey+index">
                          <!-- <v-icon 
                            v-if="ordersData[order.id].orderedProducts[opKey].warehouseStatus"
                            :color="ordersData[order.id].orderedProducts[opKey].warehouseStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].warehouseStatus] : '#ccc'"
                            :size="10"
                            style="padding-right:5px;"
                          >
                            fas fa-square-full
                          </v-icon>
                          <v-icon 
                            v-else
                            :size="10"
                            style="padding-right:5px;color:transparent"
                          >
                            fas fa-square-full
                          </v-icon> -->
                          <v-icon 
                            :color="ordersData[order.id].orderedProducts[opKey].deliveryStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].deliveryStatus] : '#ccc'"
                            :size="8"
                            style="padding-right:2px;"
                          >
                            fas fa-square-full
                          </v-icon>
                          <v-icon 
                            v-if="!order.sample"
                            :color="ordersData[order.id].orderedProducts[opKey].invoiceStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].invoiceStatus] : '#ccc'"
                            :size="8"
                            style="padding-right:0px;"
                          >
                            fas fa-square-full
                          </v-icon>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="2" class="pr-1 text-left">
                      <PaymentStatus v-if="orders[order.id] !== undefined && orders[order.id].invoices !== undefined && orders[order.id].invoicesAllPaid !== undefined" :order="orders[order.id]" />
                    </v-col>
                  </v-row>
                  
                </v-col>
              </v-row>  
            </v-col>
          </v-row>
        </v-lazy>
      </div>
    </div>
    <div v-if="orderFilter === 'yearMonthInvoiced' || orderFilter === 'invoiced'">
      <v-row no-gutters class="order-margins-headers" id="order-margins-headers" style="background:#EEEEEE;">
        <v-col cols="6">
          <v-row no-gutters>
              <v-col sm="1" class="orders-custom-header pr-1"></v-col>
              <!-- <v-col sm="1" class="orders-custom-header pr-1">Laskutettu pvm</v-col> -->
              <v-col sm="1" class="orders-custom-header pr-1 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'invoicedDate'; sortAsc = !sortAsc">Laskutettu pvm</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Tilauspäivä</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Netvisor id</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Myyjä</v-col>
              <v-col sm="2" class="orders-custom-header pr-1">Yritys</v-col>
              <!-- <v-col sm="2" class="orders-custom-header pr-1">Y-tunnus</v-col> -->
              <v-col sm="3" class="orders-custom-header pr-1">Tuote</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Toimituskulut</v-col>
              <v-col sm="1" class="orders-custom-header pr-1">Yhteensä</v-col>
          </v-row>  
        </v-col>
        <v-col cols="6">
          <v-row no-gutters>
            <v-col sm="3" class="orders-custom-header pr-1">Myyjän Kommentti</v-col>
            <!-- <v-col sm="1" class="orders-custom-header pr-1">Myyjän Kate</v-col> -->
            <v-col sm="3" class="orders-custom-header pr-1" v-if="staff[user.uid] !== undefined && (staff[user.uid].role == 'admin' || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')">Toimiston Kommentti</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Myyjän Kate</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Toimiston Kate</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Toim. kulut Kate</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Lask. Kate</v-col>
            <v-col sm="1" class="orders-custom-header pr-1">Toimiston Katekommentti</v-col>
            <v-col sm="1" class="orders-custom-header pr-5 text-right">Status</v-col>
          </v-row>  
        </v-col>
        
      </v-row>
        
      <div class="order-margins-content" id="order-margins-content" style="margin-bottom:450px;" >
        <v-lazy
          style="width:100%; padding:0px;min-height:30px;"
          :options="{
            threshold: .1
          }"
          v-for="(op, index) in getOrderedProducts"
          :class="getClassesForOpRow(op)"
          :key="op.id"
        >
          <v-row no-gutters  class="order-margins-row">
            <v-col cols="6">
              <v-row no-gutters>
                <v-col sm="1" class="pr-1 text-center">
                    <v-icon v-if="allAccess" :size="12" style="padding-right:3px;" @click="selectedOrderId = op.orderId;selectedOrderedProductIdInMargins = op.id">
                      far fa-eye
                    </v-icon>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <span class="orders-custom-field" style="color:rgba(0,0,0,.38);" >{{ op.whenToInvoice ? customFormatter(op.whenToInvoice) : '' }}</span>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <span class="orders-custom-field" style="color:rgba(0,0,0,.38);" >{{ op.created_at ? customFormatter(op.created_at) : '' }}</span>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(op.netvisorId)" style="color:rgba(0,0,0,.38);">{{op.netvisorId}}</div>
                  <!-- <v-text-field :value="op.netvisorId" @change="v => inlineSaveField(op.id,'netvisorId',v)"  hide-details class="avecor-select"></v-text-field> -->
                </v-col>
                <v-col sm="1" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(op.firstName)" style="color:rgba(0,0,0,.38);">{{staff[op.salespersonId].firstName}}</div>
                </v-col>
                <v-col sm="2" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(companies[op.companyId].companyName)" style="color:rgba(0,0,0,.38);">{{companies[op.companyId].companyName}}</div>
                </v-col>
                <v-col sm="3" class="pr-1">
                  <div class="orders-custom-field" @click="copyToClipboard(op.orderSummary)" style="color:rgba(0,0,0,.38);">
                    <i v-if="products[op.productId] && products[op.productId].isMarginCalculationActivated" class="fas fa-money-check-alt mr-1" style="color:green" ></i>
                    {{op.orderSummary}}
                  </div>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-text-field
                    slot="input"
                    :value="op.deliveryCharge + '€'"
                    class="avecor-select"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <div class="orders-custom-field" 
                    @click="copyToClipboard((Number(op.total) + Number(op.deliveryCharge)).toFixed(2))" 
                    style="color:rgba(0,0,0,.38);">
                    {{(Number(op.total) + Number(op.deliveryCharge)).toFixed(2) + '€'}}
                  </div>
                  <!-- <v-text-field
                    slot="input"
                    :value="getTotal(op.orderId) + '€'"
                    single-line
                    class="avecor-select"
                    disabled
                  ></v-text-field> -->
                </v-col>
              </v-row>  
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col sm="3" class="pr-1">
                  <div class="orders-custom-field" 
                    @click="copyToClipboard(orders[op.orderId].orderComments)" 
                    style="color:rgba(0,0,0,.38);">
                    {{orders[op.orderId].orderComments}}
                  </div>
                  <!-- <v-textarea
                    :value="order.orderComments"
                    @change="v => inlineSaveField(op.orderId,'orderComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select"
                  ></v-textarea> -->
                </v-col>
                <!-- <v-col sm="1" class="pr-1">
                  <v-text-field
                    :value="orders[op.orderId].salespersonMargin"
                    @change="v => inlineSaveField(op.orderId,'salespersonMargin',v)"
                    single-line
                    class="avecor-select"
                  ></v-text-field>
                </v-col> -->
                <v-col sm="3" class="pr-1" >
                  <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" max-width="500" v-if="allAccess">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >
                        <div v-if="orders[op.orderId].officeOrderComments" class="orders-custom-field" >{{orders[op.orderId].officeOrderComments.substring(0,100)+'...'}}</div>
                      </span>
                    </template>
                    <div style="font-size:11px;background:#FFF;">
                      <div style="padding:10px;background:#FFF;">
                      <pre><span style="font-family:Roboto, sans-serif;text-wrap:wrap;">{{orders[op.orderId].officeOrderComments}}</span></pre>
                      </div>
                    </div>
                  </v-menu>
                  <!-- <v-textarea
                    :value="orders[op.orderId].officeOrderComments"
                    @change="v => inlineSaveField(op.orderId,'officeOrderComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select"
                  ></v-textarea> -->
                  
                </v-col>
                <v-col sm="1" class="pr-1 pl-1">
                  <v-text-field
                    :value="op.salespersonMargin"
                    @change="v => inlineSaveOrderedProductField(op.id,'salespersonMargin',v)"
                    single-line
                    style="background:#eee;"
                    hide-details
                    class="avecor-select pl-2"
                  ></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1 pl-1">
                  <v-text-field
                    :disabled="!allAccess"
                    :value="op.confirmedMargin"
                    @change="v => inlineSaveOrderedProductField(op.id,'confirmedMargin',v)"
                    single-line
                    style="background:#eee;"
                    hide-details
                    class="avecor-select pl-2"
                  ></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1 pl-1">
                  <v-text-field
                    :disabled="true"
                    :value="op.deliveryMarginPerProduct"
                    single-line
                    style="background:#eee;"
                    hide-details
                    class="avecor-select pl-2"
                  ></v-text-field>
                </v-col>
                <v-col sm="1" class="pr-1 pl-1">
                  <v-text-field
                    :disabled="true"
                    :value="op.confirmedMargin + op.deliveryMarginPerProduct"
                    single-line
                    style="background:#eee;"
                    hide-details
                    class="avecor-select pl-2"
                  ></v-text-field>
                </v-col>
                
                <!--<v-flex xs12 sm8 md2 pr-1 v-if="staff[user.uid].role == 'admin' || staff[user.uid].role == 'office'">-->
                <v-col sm="1" class="pr-1">
                  <v-textarea
                    :disabled="!allAccess"
                    :value="orders[op.orderId].officeOrderMarginComments"
                    @change="v => inlineSaveField(op.orderId,'officeOrderMarginComments',v)"
                    single-line
                    rows=1
                    :auto-grow="autogrow"
                    class="avecor-select pl-2"
                  ></v-textarea>
                </v-col>
                <v-col sm="1" class="pr-1">
                  <v-row no-gutters>
                    <v-col cols="3" class="pr-2 text-left"></v-col>
                    <v-col cols="9" class="pr-2 text-center">
                      <v-icon 
                        :color="op.deliveryStatus ? settings.orderStatusColors[op.deliveryStatus] : '#ccc'"
                        :size="8"
                        style="padding-right:2px;"
                      >
                        fas fa-square-full
                      </v-icon>
                      <v-icon 
                        v-if="!op.sample"
                        :color="op.orderInvoiceStatus ? settings.orderStatusColors[op.orderInvoiceStatus] : '#ccc'"
                        :size="8"
                        style="padding-right:0px;"
                      >
                        fas fa-square-full
                      </v-icon>
                      <div style="font-size:11px;">
                        <!-- if (marginRate < 2) marginRateColor = "#DE3164"
            else if (marginRate >= 2 && marginRate <= 2.5) marginRateColor = "#FFBF00"
            else if(marginRate > 2.5) marginRateColor = "#2ECC40" -->
                        <v-icon 
                          v-if="op.marginRate < 2"
                          :color="'#DE3164'"
                          :size="8"
                          style="padding-right:0px;"
                        >
                          fas fa-square-full
                        </v-icon>
                        <v-icon 
                          v-else-if="op.marginRate >= 2 && op.marginRate <= 2.5"
                          :color="'#FFBF00'"
                          :size="8"
                          style="padding-right:0px;"
                        >
                          fas fa-square-full
                        </v-icon>
                        <v-icon 
                          v-else-if="op.marginRate > 2.5"
                          :color="'#2ECC40'"
                          :size="8"
                          style="padding-right:0px;"
                        >
                          fas fa-square-full
                        </v-icon>
                        {{ op.marginRate }}
                      </div>
                      <!-- <div v-if="ordersData[op.orderId] !== undefined && ordersData[op.orderId].orderedProducts !== undefined">
                        <div v-for="(opKey, index) in Object.keys(ordersData[op.orderId].orderedProducts)" :key="'op-status-'+opKey+index">
                          
                        </div>
                      </div> -->
                    </v-col>
                    <!-- <v-col cols="2" class="pr-1 text-left">
                      <PaymentStatus v-if="orders[op.orderId] !== undefined && orders[op.orderId].invoices !== undefined && orders[op.orderId].invoicesAllPaid !== undefined" :order="orders[op.orderId]" />
                    </v-col> -->
                  </v-row>
                  
                </v-col>
              </v-row>  
            </v-col>
          </v-row>
        </v-lazy>
      </div>
    </div>
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import OrderExpand from './OrderExpand'
import PaymentStatus from './PaymentStatus'
import { ExportToCsv } from 'export-to-csv';
import shared from './../../shared'

export default {
    components: {
      OrderExpand,
      PaymentStatus
    },
    created () {
      this.generateDeliveryMarginsByOrder = shared.generateDeliveryMarginsByOrder
      this.generateMarginsTableData = shared.generateMarginsTableData
    },
    data: () => ({
      selectedYearMonthForInvoiced:'',
      sortColumn:'invoicedDate',
      sortAsc:true,
      ordersData:{},
      opsData:{},
      numberOfInvoicedOpsMarginCalculatedInSelectedMonth:0,
      numberOfInvoicedOpsInSelectedMonth:0,
      orderExpansions:{},
      marginsSearchTerm:"",
      pagination: {'sortBy': 'created_at', 'descending': true, 'rowsPerPage': 15, 'sortable':false},
      yearMonthOptionsForInvoiced:{},
      
      rowsPerPageItems:[15,30],
      dialog: false,
      productDialog: false,
      orderFilter: "yearMonthInvoiced",
      table: null,
      autogrow: true,
      search: '',
      editedIndex: -1,
      addedDatePickerMenuMaster: false,
      latestToCustomerDatePickerMenuMaster : false,
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10),
      months:[1,2,3,4,5,6,7,8,9,10,11,12],
    }),
    watch: {
      orderedProducts: {
        handler(val){
          this.generateOrdersData()
          this.generateOrderedProductsData()
        },
        deep: true
      },
      orders: {
        handler(val){
          //this.generateOrdersData()
          this.generateOrderedProductsData()
        },
        deep: true
      }
      
    },
    mounted() {
      this.marginsSearch = this.marginsSearchTerm
      this.generateOrdersData()
      this.generateOrderedProductsData()

      // ACTIVATE TO SHOW THE MONTH TO PROCESS
      var selectedYearMonthForInvoiced = this.getYearMonthOptionsForInvoiced[1] ? this.getYearMonthOptionsForInvoiced[1] : ''
      this.selectedYearMonthForInvoiced = selectedYearMonthForInvoiced

      //this.selectedYearMonthForInvoiced = 'all'
      //this.generateInitialOrderStatuses()

      // When the user scrolls the page, execute myFunction 
      window.onscroll = function() {myFunction()};

      

      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      function myFunction() {
        // Get the header
        var header = document.getElementById("order-margins-headers");
        var content = document.getElementById("order-margins-content");
        
        // Get the offset position of the navbar
        if(header){
          var stickyOffset = header.offsetTop;
          var contentOffset = content.offsetTop
          if(window.pageYOffset < contentOffset -50){
            header.classList.remove("order-margins-headers-sticky");
          }
          else if (window.pageYOffset > stickyOffset) {
            header.classList.add("order-margins-headers-sticky");
          } else {
            header.classList.remove("order-margins-headers-sticky");
          }
        }
      }
    },
    computed: {
      /* user(){
        return {uid:'2hq19s6eQHSrEhwXiAeDGxo0Q5e2'}
      }, */
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getYearMonthOptionsForInvoiced(){
        var yearMonthOptionsForInvoiced = this.yearMonthOptionsForInvoiced
        var options = []
        Object.keys(yearMonthOptionsForInvoiced).forEach(y => {
          Object.keys(yearMonthOptionsForInvoiced[y]).forEach(m => {
            m = Number(m)
            if (m < 10) m = '0'+m
            options.push(y+"-"+m)
          })
        })
        options.sort((a,b)=>{
          if (a > b) {return -1;}
          if (b > a) {return 1;}
          return 0;
        })
        return options
      },
      getOrders(){
        var selectedOrders = []
        var o 
        for (const key of Object.keys(this.ordersData)) {
          o = this.ordersData[key]
          if (this.marginsSearch !== ""){
            var orderTextsToSearch = ""
            if(o.orderSummary !== undefined) orderTextsToSearch += o.orderSummary
            if(o.orderSummaryIds !== undefined) orderTextsToSearch += o.orderSummaryIds
            if(this.companies[o.companyId] !== undefined) orderTextsToSearch += this.companies[o.companyId].companyId
            if(o.companyName !== undefined) orderTextsToSearch += o.companyName
            if(o.contactPhone !== undefined) orderTextsToSearch += o.contactPhone
            if(o.contactEmail !== undefined) orderTextsToSearch += o.contactEmail
            if(o.companyAddress !== undefined) orderTextsToSearch += o.companyAddress
            if(o.contactName !== undefined) orderTextsToSearch += o.contactName
            if(o.netvisorId !== undefined) orderTextsToSearch += o.netvisorId
            if(o.billingReferenceDetails !== undefined) orderTextsToSearch += o.billingReferenceDetails
            if(o.printShops !== undefined) orderTextsToSearch += o.printShops
            if(o.wholesaleCompanies !== undefined) orderTextsToSearch += o.wholesaleCompanies
            if(o.salespersonFirstName !== undefined) orderTextsToSearch += o.salespersonFirstName
            if(this.orders[key].officeOrderComments !== undefined) orderTextsToSearch += this.orders[key].officeOrderComments
            if(this.orders[key].orderComments !== undefined) orderTextsToSearch += this.orders[key].orderComments

            if(orderTextsToSearch.toLowerCase().includes(this.marginsSearch.toLowerCase())) {
              if(this.staff[this.user.uid].role === 'sales' && o.salesperson === this.user.uid) selectedOrders.push(o)
              else if (this.staff[this.user.uid].role === "admin" || this.staff[this.user.uid].role === "office") selectedOrders.push(o)
            }
          }
          else{
            if (this.staff[this.user.uid].role === 'sales' && o.salespersonId !== this.user.uid) continue
            else {
              if (this.orderFilter === "lessThanTwoMonthsInvoicesAllPaid"){
                if(this.orders[key].invoicesAllPaid){
                  var twoMonthsAgo = new Date(); 
                  twoMonthsAgo.setMonth(twoMonthsAgo.getMonth()-2)
                  if(this.orders[key].invoicesPaidDate && this.orders[key].invoicesPaidDate.seconds){
                    
                    var invoicesPaidDate = new Date(this.orders[key].invoicesPaidDate.seconds*1000);
                    if (invoicesPaidDate > twoMonthsAgo) {
                      selectedOrders.push(o)
                    }
                  }
                }
              }
              else if (this.orderFilter === "invoicesAllPaid"){
                this.orders[key].invoicesAllPaid ? selectedOrders.push(o) : ''
              }
              else if (this.orderFilter === "lessThanTwoMonths"){
                var twoMonthsAgo = new Date(); twoMonthsAgo.setMonth(twoMonthsAgo.getMonth()-2)
                if(this.orders[key].created_at.seconds){
                  var orderDate = new Date(this.orders[key].created_at.seconds*1000);
                  if (orderDate > twoMonthsAgo) selectedOrders.push(o)
                }
              }
              else if(this.orderFilter === "allOrders") {
                selectedOrders.push(o)
              }
            }
          }
        }

        // SORT
        if (this.orderFilter === "invoicesAllPaid" || this.orderFilter === "lessThanTwoMonthsInvoicesAllPaid"){
          selectedOrders = selectedOrders.sort(function(a,b){
            var aDate = a.invoicesPaidDate.seconds
            var bDate = b.invoicesPaidDate.seconds
            return bDate - aDate;
          });
        }

        return selectedOrders
      },
      getOrderedProducts(){
        var selectedOrders = []
        var filterDateStart, filterDateEnd = null
        this.numberOfInvoicedOpsMarginCalculatedInSelectedMonth = 0
        this.numberOfInvoicedOpsInSelectedMonth = 0
        if(!this.selectedYearMonthForInvoiced) return selectedOrders
        

        if(this.selectedYearMonthForInvoiced !== 'all'){
          var pieces = this.selectedYearMonthForInvoiced.split("-")
          var selectedYear = pieces[0]
          var selectedMonth = pieces[1]
          //if(selectedMonth.includes('0')) selectedMonth = selectedMonth.charAt(1);
          selectedMonth = Number(selectedMonth)
          selectedMonth = selectedMonth - 1

          filterDateStart = new Date(selectedYear,selectedMonth,1,23,59,59)
          filterDateStart.setDate(filterDateStart.getDate() - 1);

          filterDateEnd = new Date(selectedYear,selectedMonth,1,23,59,59)
          filterDateEnd.setMonth(filterDateEnd.getMonth() + 1);
          filterDateEnd.setDate(filterDateEnd.getDate() - 1);
        }
        console.log({filterDateStart,filterDateEnd})
        
        var op
        for (const key of Object.keys(this.opsData)) {
          op = this.opsData[key]
          //CALCULATE NUMBER OF INVOICED AND TOTAL INVOICED IN TIME PERIOD
          if (this.orderFilter === "yearMonthInvoiced"){
            if(this.selectedYearMonthForInvoiced === 'all') {
              if(op.confirmedMargin !== undefined) this.numberOfInvoicedOpsMarginCalculatedInSelectedMonth += 1
              this.numberOfInvoicedOpsInSelectedMonth += 1
            }
            else {
              var whenToInvoiceDate = new Date(op.whenToInvoice.seconds*1000);
              if(whenToInvoiceDate > filterDateStart && whenToInvoiceDate < filterDateEnd) {
                if(op.confirmedMargin !== undefined) this.numberOfInvoicedOpsMarginCalculatedInSelectedMonth += 1
                this.numberOfInvoicedOpsInSelectedMonth += 1
              }
            }
          }
          var searchOk = true
          var includeInSelected = false
          
          if (this.staff[this.user.uid].role === 'sales' && op.salespersonId !== this.user.uid) continue
          if (this.marginsSearchInvoiced !== ""){
            var marginsSearchInvoiced = this.marginsSearchInvoiced.toLowerCase()
            var opTextsToSearch = ""
            if(this.marginsSearchInvoiced.startsWith('m:')){
              if(op.salespersonFirstName !== undefined) opTextsToSearch += op.salespersonFirstName
            }
            else{
              if(op.orderSummary !== undefined) opTextsToSearch += op.orderSummary
              if(op.orderSummaryIds !== undefined) opTextsToSearch += op.orderSummaryIds
              if(this.companies[op.companyId] !== undefined) opTextsToSearch += this.companies[op.companyId].companyId
              if(op.companyName !== undefined) opTextsToSearch += op.companyName
              if(op.contactPhone !== undefined) opTextsToSearch += op.contactPhone
              if(op.contactEmail !== undefined) opTextsToSearch += op.contactEmail
              if(op.companyAddress !== undefined) opTextsToSearch += op.companyAddress
              if(op.contactName !== undefined) opTextsToSearch += op.contactName
              if(op.netvisorId !== undefined) opTextsToSearch += op.netvisorId
              if(op.billingReferenceDetails !== undefined) opTextsToSearch += op.billingReferenceDetails
              if(op.salespersonFirstName !== undefined) opTextsToSearch += op.salespersonFirstName
              if(this.orders[op.orderId].officeOrderComments !== undefined) opTextsToSearch += this.orders[op.orderId].officeOrderComments
              if(this.orders[op.orderId].orderComments !== undefined) opTextsToSearch += this.orders[op.orderId].orderComments
            }
            if(marginsSearchInvoiced.startsWith('m:')) {
              marginsSearchInvoiced = marginsSearchInvoiced.replace("m:", '')
              console.log()
            }

            if(!opTextsToSearch.toLowerCase().includes(marginsSearchInvoiced.toLowerCase())) {
              searchOk = false
              /* if(this.staff[this.user.uid].role === 'sales' && op.salesperson === this.user.uid) selectedOrders.push(op)
              else if (this.staff[this.user.uid].role === "admin" || this.staff[this.user.uid].role === "office") selectedOrders.push(op) */
            }
          }
          
          if (this.orderFilter === "lessThanTwoMonthsInvoiced"){
            if(op.whenToInvoice){

              var twoMonthsAgo = new Date(); 
              twoMonthsAgo.setMonth(twoMonthsAgo.getMonth()-2)
              if(op.whenToInvoice && op.whenToInvoice.seconds){
                var whenToInvoiceDate = new Date(op.whenToInvoice.seconds*1000);
                if (whenToInvoiceDate > twoMonthsAgo) {
                  includeInSelected = true
                }
              }
            }
          }
          else if (this.orderFilter === "yearMonthInvoiced"){
            if(this.selectedYearMonthForInvoiced === 'all') includeInSelected = true
            else {
              var whenToInvoiceDate = new Date(op.whenToInvoice.seconds*1000);
              if(whenToInvoiceDate > filterDateStart && whenToInvoiceDate < filterDateEnd) {
                includeInSelected = true
              }
            }
          }
          else if (this.orderFilter === "invoiced"){
            includeInSelected = true
          }
          
          if(searchOk && includeInSelected) selectedOrders.push(op)
        }

        var sortAsc = this.sortAsc
        selectedOrders = selectedOrders.sort(function(a,b){
          var aDate = a.whenToInvoice.seconds
          var bDate = b.whenToInvoice.seconds
          if(sortAsc){
            return aDate - bDate
          }
          else{
            return bDate - aDate
          }
        });
        
        /* selectedOrders = selectedOrders.sort(function(a,b){
          var aDate = a.whenToInvoice.seconds
          var bDate = b.whenToInvoice.seconds
          return bDate - aDate;
        }); */
        return selectedOrders
      },
      getOrderResponsibles(){
        var orderResponsibles = this.settings.orderResponsibles
        return Object.keys(this.settings.orderResponsibles).reduce(function(result, key) {
          result.push({...orderResponsibles[key]});
          return result;
        }, []);
      },
      getOfficeStaff(){
        var staff = this.staff
        var officeStaff = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.role.includes('office')) officeStaff.push({text:s.firstName, id:s.id})
          
          return s
        })
        return officeStaff
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
      ...mapFields({
        settings:"settings",
        user:"user",
        marginsSearch:"settings.marginsSearch",
        marginsSearchInvoiced:"settings.marginsSearchInvoiced",
        orderProductsSearch:"settings.orderProductsSearch",
        orderedProductsStatuses:"views.orders.orderedProductsStatuses",
        salesConsole:"views.salesConsole",
        companies:"company.companies",
        contacts:"contact.contacts",
        orderedProducts:"orderedProduct.orderedProducts",

        productVariations:"productVariation.productVariations",
        staff:"staff.staff",
        orders:"order.orders",
        companySelectedInModel:"settings.companySelectedInModel",
        products:"product.products",
        selectedOrderId:"views.margins.selectedOrder.orderId",
        selectedOrderedProductIdInMargins:"views.margins.selectedOrder.orderedProductId",
        orderStatusColors:"settings.orderStatusColors",
        orderedProductStatusArray:"settings.orderedProductStatusArray",
        orderedProductStatusObject:"settings.orderedProductStatusObject",
        orderedProductInvoiceStatusArray:"settings.orderedProductInvoiceStatusArray"
      }),
      
    },
    methods: {
      exportMonthMargins(){
        if(selectedMonth === 'all'){
          alert("Valitse kuukausi!")
          return
        }
        
        //dataRestriction="none" chartType="table" metric="bothMargins" label="Katteet" dateSplit="months" salesperson="salespersons" :year="selectedYear"

        var salespersons = []
        var headers = []
        Object.keys(this.staff).forEach(sId => {
          var s = this.staff[sId]
          if(!s.isExit && s.role === 'sales') {
            salespersons.push(s)
            headers.push({id:s.id})
          }
        })
        headers.push({id:'all'})
        
        var selectedYearMonth = this.selectedYearMonthForInvoiced
        var selectedMonth = selectedYearMonth.split('-')[1]
        var selectedYear = selectedYearMonth.split('-')[0]
        selectedMonth = Number(selectedMonth) - 1
        
        var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()
        var data = this.generateMarginsTableData('none','bothMargins', 'table', "figures",'salespersons',"month",selectedYear, deliveryMarginsByOrder,headers)
        //(dataRestriction,metric, chartType, figureType, split,timeSplit,selectedYear,deliveryMarginsByOrder,headers) 

        var exportData = []

        if(!data[selectedMonth]) {
          alert("Valitulle kuukaudelle ei voitu muodostaa exporttia, Kontaktoi Tomia.")
          return
        }
        var monthInExport = selectedMonth + 1
        console.log(data[selectedMonth])

        var totalRow = null
        data[selectedMonth].forEach( row => {
          if(row.salespersonId === 'all') totalRow = row
        })

        data[selectedMonth].forEach( row => {
          if(!row.salespersonId || !this.staff[row.salespersonId]) return
          
          var s = this.staff[row.salespersonId]
          var invoicedMarginsOffice = row.invoicedMarginsOffice
          var invoicedMarginsOffice_level1 = row.invoicedMarginsOffice_level1
          var invoicedMarginsOffice_level2 = row.invoicedMarginsOffice_level2
          var invoicedMarginsOffice_level3 = row.invoicedMarginsOffice_level3
          
          console.log({invoicedMarginsOffice_level1,invoicedMarginsOffice_level2,invoicedMarginsOffice_level3})

          // JANNELLE TILAUSPVM MUKAAN
          if(row.salespersonId === 'MG7ysPafpYMEQtqd0HJVzck3yXM2') {
            console.log(row)
            
            invoicedMarginsOffice = row.marginsSalesperson
            invoicedMarginsOffice_level1 = row.marginsSalesperson_level1
            invoicedMarginsOffice_level2 = row.marginsSalesperson_level2
            invoicedMarginsOffice_level3 = row.marginsSalesperson_level3
          }
          var invoicedMarginsOffice = Number(invoicedMarginsOffice)
          var commissionRate = 0
          var commissionRate_level1 = 0
          var commissionRate_level2 = 0
          var commissionRate_level3 = 0
          var expenseLimit = 0

          if(s.expenseLimit) expenseLimit = Number(s.expenseLimit)
          if(s.commissionRate) commissionRate = Number(s.commissionRate)
          console.log(s)
          if(s.commissionRate_level1) commissionRate_level1 = Number(s.commissionRate_level1)
          if(s.commissionRate_level2) commissionRate_level2 = Number(s.commissionRate_level2)
          if(s.commissionRate_level3) commissionRate_level3 = Number(s.commissionRate_level3)

          var commissionRateForCalc = Number(commissionRate/100)
          var commissionRateForCalc_level1 = Number(commissionRate_level1/100)
          var commissionRateForCalc_level2 = Number(commissionRate_level2/100)
          var commissionRateForCalc_level3 = Number(commissionRate_level3/100)
          
          var paymentAmount = invoicedMarginsOffice * commissionRateForCalc
          var paymentAmount_level1 = invoicedMarginsOffice_level1 * commissionRateForCalc_level1
          var paymentAmount_level2 = invoicedMarginsOffice_level2 * commissionRateForCalc_level2
          var paymentAmount_level3 = invoicedMarginsOffice_level3 * commissionRateForCalc_level3
          
          paymentAmount = paymentAmount.toFixed(2)
          paymentAmount_level1 = paymentAmount_level1.toFixed(2)
          paymentAmount_level2 = paymentAmount_level2.toFixed(2)
          paymentAmount_level3 = paymentAmount_level3.toFixed(2)
          
          commissionRate = commissionRate + ''
          commissionRate_level1 = commissionRate_level1 + ''
          commissionRate_level2 = commissionRate_level2 + ''
          commissionRate_level3 = commissionRate_level3 + ''

          if(!commissionRate.includes('.')) commissionRate = commissionRate + '.0'
          if(!commissionRate_level1.includes('.')) commissionRate_level1 = commissionRate_level1 + '.0'
          if(!commissionRate_level2.includes('.')) commissionRate_level2 = commissionRate_level2 + '.0'
          if(!commissionRate_level3.includes('.')) commissionRate_level3 = commissionRate_level3 + '.0'

          commissionRate = commissionRate.trim()
          commissionRate_level1 = commissionRate_level1.trim()
          commissionRate_level2 = commissionRate_level2.trim()
          commissionRate_level3 = commissionRate_level3.trim()
          
          commissionRate = commissionRate+'%'
          commissionRate_level1 = commissionRate_level1+'%'
          commissionRate_level2 = commissionRate_level2+'%'
          commissionRate_level3 = commissionRate_level3+'%'
          
          invoicedMarginsOffice = invoicedMarginsOffice.toFixed(2)
          /* invoicedMarginsOffice_level1 = invoicedMarginsOffice_level1.toFixed(2)
          invoicedMarginsOffice_level2 = invoicedMarginsOffice_level2.toFixed(2)
          invoicedMarginsOffice_level3 = invoicedMarginsOffice_level3.toFixed(2) */


          

          

          if((monthInExport < 4 && selectedYear == 2025) || selectedYear < 2025){
            var marginRow = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              marginRate:'Kaikki',
              totalMargin:invoicedMarginsOffice,
              commissionRate,
              paymentAmount
            }
            exportData.push(marginRow)
          }
          
          if((monthInExport >= 4 && selectedYear == 2025) || selectedYear > 2025){
            var marginRow_level1 = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              marginRate:'Alle 2,00',
              totalMargin:invoicedMarginsOffice_level1,
              commissionRate:commissionRate_level1,
              paymentAmount:paymentAmount_level1
            }
            var marginRow_level2 = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              marginRate:'2,0-2,49',
              totalMargin:invoicedMarginsOffice_level2,
              commissionRate:commissionRate_level2,
              paymentAmount:paymentAmount_level2
            }
            var marginRow_level3 = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              marginRate:'Yli 2,5',
              totalMargin:invoicedMarginsOffice_level3,
              commissionRate:commissionRate_level3,
              paymentAmount:paymentAmount_level3
            }

            exportData.push(marginRow_level1)
            exportData.push(marginRow_level2)
            exportData.push(marginRow_level3)
          }


          // SAMI
          if(row.salespersonId === 'CfssvG9CYWWCoLSkeoR6FVXy6K72'){
            var totalMonthInvoicedMarginsOffice = totalRow.invoicedMarginsOffice
            totalMonthInvoicedMarginsOffice = Number(totalMonthInvoicedMarginsOffice)
            var paymentFromTotalMonthInvoicedMarginsOffice = totalMonthInvoicedMarginsOffice * 0.01
            paymentFromTotalMonthInvoicedMarginsOffice = paymentFromTotalMonthInvoicedMarginsOffice.toFixed(2)
            var marginRowExtra = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              marginRate:'',
              totalMargin:totalMonthInvoicedMarginsOffice,
              commissionRate:'1.0%',
              paymentAmount:paymentFromTotalMonthInvoicedMarginsOffice
            }
            
            exportData.push(marginRowExtra)  
          }
          // HENRI
          if(row.salespersonId === 'zNBbbWRgacVUU3TU06kTSLesn872'){
            if((monthInExport >= 4 && selectedYear == 2025) || selectedYear > 2025){
              var totalMonthInvoicedMarginsOffice = totalRow.invoicedMarginsOffice
              totalMonthInvoicedMarginsOffice = Number(totalMonthInvoicedMarginsOffice)
              var paymentFromTotalMonthInvoicedMarginsOffice = 0
              var extraCommissionRate = 0.01
              
              var paymentFromTotalMonthInvoicedMarginsOffice = totalMonthInvoicedMarginsOffice * extraCommissionRate
              paymentFromTotalMonthInvoicedMarginsOffice = paymentFromTotalMonthInvoicedMarginsOffice.toFixed(2)
              
              var marginRowExtra = {
                year:selectedYear,
                month:monthInExport,
                myyjä: s.firstName + ' ' + s.lastName,
                expenseLimit,
                marginRate:'',
                totalMargin:totalMonthInvoicedMarginsOffice,
                commissionRate:'1.0%',
                paymentAmount:paymentFromTotalMonthInvoicedMarginsOffice
              }
              exportData.push(marginRowExtra)  
            }
            else {
              var totalMonthInvoicedMarginsOffice = totalRow.invoicedMarginsOffice
              totalMonthInvoicedMarginsOffice = Number(totalMonthInvoicedMarginsOffice)
              var paymentFromTotalMonthInvoicedMarginsOffice = 0
              var extraCommissionRate = 0
              if(totalMonthInvoicedMarginsOffice < 130000) extraCommissionRate = 0.015
              if(totalMonthInvoicedMarginsOffice > 130000) extraCommissionRate = 0.0175
              if(totalMonthInvoicedMarginsOffice > 160000) extraCommissionRate = 0.02
              var commissionRateToShow = extraCommissionRate * 100
              var paymentFromTotalMonthInvoicedMarginsOffice = totalMonthInvoicedMarginsOffice * extraCommissionRate
              paymentFromTotalMonthInvoicedMarginsOffice = paymentFromTotalMonthInvoicedMarginsOffice.toFixed(2)
              var commissionRateToShow = commissionRateToShow.toFixed(2)
              var marginRowExtra = {
                year:selectedYear,
                month:monthInExport,
                myyjä: s.firstName + ' ' + s.lastName,
                expenseLimit,
                marginRate:'',
                totalMargin:totalMonthInvoicedMarginsOffice,
                commissionRate:commissionRateToShow + '%',
                paymentAmount:paymentFromTotalMonthInvoicedMarginsOffice
              }
              exportData.push(marginRowExtra)  
            }
          }
          // HENRI EXTRA OLD
          /* if(row.salespersonId === 'zNBbbWRgacVUU3TU06kTSLesn872'){
            var totalMonthInvoicedMarginsOffice = totalRow.invoicedMarginsOffice
            totalMonthInvoicedMarginsOffice = Number(totalMonthInvoicedMarginsOffice)
            var paymentFromTotalMonthInvoicedMarginsOffice = 0
            var extraCommissionRate = 0
            if(totalMonthInvoicedMarginsOffice < 130000) extraCommissionRate = 0.015
            if(totalMonthInvoicedMarginsOffice > 130000) extraCommissionRate = 0.0175
            if(totalMonthInvoicedMarginsOffice > 160000) extraCommissionRate = 0.02
            var commissionRateToShow = extraCommissionRate * 100
            var paymentFromTotalMonthInvoicedMarginsOffice = totalMonthInvoicedMarginsOffice * extraCommissionRate
            paymentFromTotalMonthInvoicedMarginsOffice = paymentFromTotalMonthInvoicedMarginsOffice.toFixed(2)
            var commissionRateToShow = commissionRateToShow.toFixed(2)
            var marginRowExtra = {
              year:selectedYear,
              month:monthInExport,
              myyjä: s.firstName + ' ' + s.lastName,
              expenseLimit,
              totalMargin:totalMonthInvoicedMarginsOffice,
              commissionRate:commissionRateToShow + '%',
              paymentAmount:paymentFromTotalMonthInvoicedMarginsOffice
            }
            
            exportData.push(marginRowExtra)  
          } */
          
        })

        console.log(exportData)
        
        
   
        var name = "Avecor_Katteet-" + selectedYear + '-' + monthInExport

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:name, 
          useTextFile: false,
          useBom: true,
          //useKeysAsHeaders: true,
          headers: ['Vuosi', 'Kuukausi', 'Myyjä', 'Kulukatto', 'Katekerroin','Kate', 'Provisioprosentti', 'Maksuun']
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(exportData);
      },
      getClassesForOpRow(item){
        //avecor-selected-op-row-office-margin-added
        //avecor-selected-op-row-office-margin-not-added
        var classes = 'hide-field-details'
        item.confirmedMargin ? classes += ' avecor-selected-op-row-office-margin-added' : ''
        !item.confirmedMargin ? classes += ' avecor-selected-op-row-office-margin-not-added' : ''
         
        return classes
      },
      generateOrdersData(){
        var ordersData = {}
        //var t = this
        //Object.keys(this.orderedProducts).map(function(key, index) {
        //if (!this.loaded) return ordersData
        var op,pv
        for (const key of Object.keys(this.orderedProducts)) {
          op = this.orderedProducts[key]
          pv = this.productVariations[op.productVariationId] !== undefined ? this.productVariations[op.productVariationId] : {}
          if(this.orders[op.orderId] === undefined){
            console.log("GENERATING ORDERS: ORDER NOT FOUND FOR ORDER ID: "+ op.orderId +" VIA OP ID: " + op.id) 
            continue
          } 

          //continue
          if(this.companies[this.orders[op.orderId].companyId] === undefined) {
            console.log("HRE")
            console.log("GENERATING ORDERS: COMPANY NOT FOUND ID: " + this.orders[op.orderId].companyId + " ORDERD ID: " +op.orderId) 
            continue
          }
          
          
          //if(this.filterCompanyId !== undefined && this.orders[op.orderId].companyId !== this.filterCompanyId) { return {}}
          typeof ordersData[op.orderId] === "undefined" ? ordersData[op.orderId] = {} : ""
          //typeof productsData[pv.productId] === "undefined" ? productsData[pv.productId] = {} : ""
          Object.defineProperty(ordersData, op.orderId, { configurable: false });
          
          ordersData[op.orderId].id = op.orderId
          ordersData[op.orderId].orderedProducts === undefined ? ordersData[op.orderId].orderedProducts = {} : ""
          ordersData[op.orderId].invoiceStatuses === undefined ? ordersData[op.orderId].invoiceStatuses = [] : ""
          ordersData[op.orderId].orderStatuses === undefined ? ordersData[op.orderId].orderStatuses = [] : ""
          ordersData[op.orderId].orderAndInvoiceStatuses === undefined ? ordersData[op.orderId].orderAndInvoiceStatuses = [] : ""
          ordersData[op.orderId].currentResponsibles === undefined ? ordersData[op.orderId].currentResponsibles = [] : ""
          
          
          if (this.orders[op.orderId].created_at !== undefined && this.orders[op.orderId].created_at.seconds !== undefined){
            ordersData[op.orderId].created_at = this.orders[op.orderId].created_at
          }
          else if (this.orders[op.orderId].created_at !== undefined && this.orders[op.orderId].created_at.seconds === undefined) {
            var seconds = new Date(this.orders[op.orderId].created_at).getTime()/1000
            ordersData[op.orderId].created_at = {seconds}
            //console.log(ordersData[op.orderId].created_at)
            //console.log(op.orderId)
          }
          else ordersData[op.orderId].created_at = ""

          //this.orders[op.orderId].created_at !== undefined ? ordersData[op.orderId].created_at = this.orders[op.orderId].created_at : ordersData[op.orderId].created_at = ''
          
          var total = 0
          try{
            total = Number(op.printQuantity)*Number(op.unitPrintPrice) 
              + Number(op.quantity)*Number(op.unitPrice) 
              + Number(op.numberOfPositionings)*Number(op.pricePerPositioning) 
            //total = total.toFixed(2)
            if(isNaN(total) ) total = 0
            else total = total.toFixed(2)
            ordersData[op.orderId].total === undefined ? ordersData[op.orderId].total = total : ordersData[op.orderId].total = (Number(ordersData[op.orderId].total) + Number(total)).toFixed(2)
          }
          catch(e){
            ordersData[op.orderId].total === undefined ? ordersData[op.orderId].total = total : ordersData[op.orderId].total = (Number(ordersData[op.orderId].total) + Number(total)).toFixed(2)
          }


          ordersData[op.orderId].deliveryCharge = this.orders[op.orderId].deliveryCharge
          ordersData[op.orderId].billingReferenceDetails = this.orders[op.orderId].billingReferenceDetails !== undefined ? this.orders[op.orderId].billingReferenceDetails : ''
          
          ordersData[op.orderId].printShops === undefined ? ordersData[op.orderId].printShops = '' : ''
          if(this.products[op.productId] && this.products[op.productId].printShops && Array.isArray(this.products[op.productId].printShops)){
            this.products[op.productId].printShops.forEach(shop => {
              this.$store.state.printShop && this.$store.state.printShop.printShops && this.$store.state.printShop.printShops[shop] ? ordersData[op.orderId].printShops += this.$store.state.printShop.printShops[shop].name +", " : ""
            })
          }
          ordersData[op.orderId].wholesaleCompanies === undefined ? ordersData[op.orderId].wholesale = '' : ''
          var wc = this.products[op.productId] && this.$store.state.wholesaleCompany && this.$store.state.wholesaleCompany.wholesaleCompanies && this.$store.state.wholesaleCompany.wholesaleCompanies[this.products[op.productId].wholesaleCompany] ? this.$store.state.wholesaleCompany.wholesaleCompanies[this.products[op.productId].wholesaleCompany] : undefined
          ordersData[op.orderId].wholesaleCompanies += wc ? wc.wholesaleCode + ' ' + wc.name : ''  

          ordersData[op.orderId].orderSummary === undefined ? ordersData[op.orderId].orderSummary = '' : ''
          ordersData[op.orderId].orderSummary += this.products[op.productId] !== undefined ? this.products[op.productId].name.fi : ''
          if(pv && pv.colorCode){
            var colorName = ""
            if(this.settings.colors[pv.colorCode]) colorName = this.settings.colors[pv.colorCode].fi
            ordersData[op.orderId].orderSummary += '-'+colorName
          }
          if(pv.size && pv.size.trim() !== ""){ordersData[op.orderId].orderSummary += '-'+pv.size} 
          ordersData[op.orderId].orderSummary += ' x ' + op.quantity + ';'
          ordersData[op.orderId].orderSummaryIds === undefined ? ordersData[op.orderId].orderSummaryIds = '' : ''
          var avecorSku = this.products[pv.productId] && this.products[pv.productId].avecorSku ? this.products[pv.productId].avecorSku : ''

          //var colorCode = pv.colorCode && this.settings.colors[pv.colorCode] ? pv.colorCode : ''
          ordersData[op.orderId].orderSummaryIds += avecorSku + '-' + pv.colorCode ? pv.colorCode : ''
          ordersData[op.orderId].orderSummaryIds += pv.wholesaleSku ? pv.wholesaleSku + ' ' : ''
          //ordersData[op.orderId].orderSummary = this.orders[op.orderId].orderSummary
          //ordersData[op.orderId].orderSummaryIds = this.orders[op.orderId].orderSummaryIds
          ordersData[op.orderId].salespersonMargin = this.orders[op.orderId].salespersonMargin

          ordersData[op.orderId].orderResponsible = this.orders[op.orderId].orderResponsible
          
          ordersData[op.orderId].netvisorId = this.orders[op.orderId].netvisorId ? this.orders[op.orderId].netvisorId :''
          ordersData[op.orderId].netvisorKey = this.orders[op.orderId].netvisorKey ? this.orders[op.orderId].netvisorKey : ''
          ordersData[op.orderId].netvisorId_test_env = this.orders[op.orderId].netvisorId_test_env ? this.orders[op.orderId].netvisorId_test_env : ''
          ordersData[op.orderId].netvisorKey_test_env = this.orders[op.orderId].netvisorKey_test_env ? this.orders[op.orderId].netvisorKey_test_env : ''
          ordersData[op.orderId].companyId = this.orders[op.orderId].companyId
          ordersData[op.orderId].deliveryWeek = this.orders[op.orderId].deliveryWeek ? this.orders[op.orderId].deliveryWeek : ''
          ordersData[op.orderId].pending = this.orders[op.orderId].pending !== undefined ? this.orders[op.orderId].pending : false
          ordersData[op.orderId].avecorOrder = this.orders[op.orderId].avecorOrder !== undefined ? this.orders[op.orderId].avecorOrder : false
          ordersData[op.orderId].shopifyOrder = this.orders[op.orderId].shopifyOrder !== undefined ? this.orders[op.orderId].shopifyOrder : false
          ordersData[op.orderId].deadline = this.orders[op.orderId].deadline !== undefined ? this.orders[op.orderId].deadline : false
          ordersData[op.orderId].sample = this.orders[op.orderId].sample !== undefined ? this.orders[op.orderId].sample : false
          ordersData[op.orderId].salespersonSample = this.orders[op.orderId].salespersonSample !== undefined ? this.orders[op.orderId].salespersonSample : false
          ordersData[op.orderId].reclaimed = this.orders[op.orderId].reclaimed !== undefined ? this.orders[op.orderId].reclaimed : false
          ordersData[op.orderId].companyName = this.companies[this.orders[op.orderId].companyId] !== undefined ? this.companies[this.orders[op.orderId].companyId].companyName : ""
          ordersData[op.orderId].totalOrders = this.companies[this.orders[op.orderId].companyId] !== undefined ? this.companies[this.orders[op.orderId].companyId].totalOrders : 1
          ordersData[op.orderId].invoicesPaidDate = this.orders[op.orderId].invoicesPaidDate ? this.orders[op.orderId].invoicesPaidDate : null
          
          try{
            var company = this.companies[this.orders[op.orderId].companyId]
            ordersData[op.orderId].companyAddress = company.deliveryAddress + " " + company.deliveryPostalCode + ", " + company.deliveryCity + " " + company.deliveryCountry
          } catch(e){ 
            ordersData[op.orderId].companyAddress = ""
          }

          ordersData[op.orderId].contactName = this.contacts[this.orders[op.orderId].contactId].firstName + " " + this.contacts[this.orders[op.orderId].contactId].lastName
          ordersData[op.orderId].contactId = this.orders[op.orderId].contactId
          ordersData[op.orderId].contactEmail = this.contacts[this.orders[op.orderId].contactId].email
          ordersData[op.orderId].contactPhone = this.contacts[this.orders[op.orderId].contactId].phone
          ordersData[op.orderId].salespersonId = this.orders[op.orderId].salesperson
          !this.staff[this.orders[op.orderId].salesperson] ? console.log(this.orders[op.orderId]) : ''
          ordersData[op.orderId].salespersonFirstName = this.staff[this.orders[op.orderId].salesperson].firstName
          
          //address
          //ordersData[op.orderId].salespersonLastName = this.staff[this.orders[op.orderId].salesperson].lastName
          op.orderInvoiceStatus !== undefined ? ordersData[op.orderId].invoiceStatuses.push(op.orderInvoiceStatus) : ordersData[op.orderId].invoiceStatuses.push("emptyStatus")
          this.settings.orderedProductStatusObject[op.orderStatus] ? ordersData[op.orderId].currentResponsibles.push(this.settings.orderedProductStatusObject[op.orderStatus].nextStepResponsible) : ''
          !this.settings.orderedProductStatusObject[op.orderStatus] ? console.log(op) : ''
          op.orderStatus !== undefined ? ordersData[op.orderId].orderStatuses.push(op.orderStatus) : ordersData[op.orderId].orderStatuses.push("emptyStatus")
          op.orderStatus !== undefined && op.orderInvoiceStatus !== undefined ? ordersData[op.orderId].orderAndInvoiceStatuses.push(op.orderStatus+'_'+op.orderInvoiceStatus) : ordersData[op.orderId].orderAndInvoiceStatuses.push("emptyStatus")
          var opArchived = op.archived ? true : false
          ordersData[op.orderId].orderedProducts[op.id] = {id: op.id, warehoused:false, archived:opArchived,latestToCustomer:op.latestToCustomer, deliveryStatus:op.orderStatus, invoiceStatus:op.orderInvoiceStatus}
          ordersData[op.orderId].areAllArchived === undefined ? ordersData[op.orderId].areAllArchived = true : ''
          ordersData[op.orderId].isAtLeastOneArchived === undefined ? ordersData[op.orderId].isAtLeastOneArchived = false : ''
          if(!opArchived) ordersData[op.orderId].areAllArchived = false
          if(opArchived) ordersData[op.orderId].isAtLeastOneArchived = true
          

          //if(this.productVariations[op.productVariationId] !== undefined && this.productVariations[op.productVariationId].warehoused) ordersData[op.orderId].orderedProducts[op.id].warehoused = true
          if(this.productVariations[op.productVariationId] !== undefined && this.productVariations[op.productVariationId].warehoused && this.orderedProducts[op.id].warehouseStatus !== undefined){
            ordersData[op.orderId].orderedProducts[op.id].warehouseStatus = this.orderedProducts[op.id].warehouseStatus
            //console.log(ordersData[op.orderId].orderedProducts[op.id].warehouseStatus)
          }
          else {
            ordersData[op.orderId].orderedProducts[op.id].warehouseStatus = null
          }

        }
        
        var sortedOrders = Object.keys(ordersData).sort(function(a,b){
          var aDate = ordersData[a].created_at.seconds
          var bDate = ordersData[b].created_at.seconds
          return bDate - aDate;
        });
        var newOrdersData = {}
        sortedOrders.map(function(key, index) {
          newOrdersData[key] = ordersData[key]
          return 
        })
        this.ordersData = newOrdersData 
      },

      generateOrderedProductsData(){
        var opsData = {}
        //var t = this
        //Object.keys(this.orderedProducts).map(function(key, index) {
        //if (!this.loaded) return ordersData
        var op,pv,o
        var yearMonthOptionsForInvoiced = {}
        var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()
        var orderedProducts = this.orderedProducts

        let marginRateByOrder = {}
        for (const opId of Object.keys(orderedProducts)) {
            const op = orderedProducts[opId]
            const o = this.orders[op.orderId]
            const deliveryCharge = !o.deliveryCharge || isNaN(Number(o.deliveryCharge)) ? 0 : Number(o.deliveryCharge)
            var confirmedMargin = 0
            // JANNE KATEKERROIN MYYJÄN KATTEELLA
            if(o.salesperson === 'MG7ysPafpYMEQtqd0HJVzck3yXM2') confirmedMargin = op.salespersonMargin ? Number(op.salespersonMargin) : 0
            else if (op.confirmedMargin) confirmedMargin = Number(op.confirmedMargin)
            else if (op.salespersonMargin) confirmedMargin = Number(op.salespersonMargin)
            var deliveryMarginByProduct = deliveryMarginsByOrder[op.orderId] ? deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct : 0
            var total = 0
            if(op.orderStatus !== 'cancelled'){
                total = Number(op.printQuantity)*Number(op.unitPrintPrice) 
                    + Number(op.quantity)*Number(op.unitPrice) 
                    + Number(op.numberOfPositionings)*Number(op.pricePerPositioning) 
            }
            //total = total.toFixed(2)
            if(isNaN(total) ) total = 0

            marginRateByOrder[op.orderId] ? '' : marginRateByOrder[op.orderId] = {officeMargin:0,sales:0,marginRate:0,netvisorId:o.netvisorId}
            // DELIVERY CHARGE INCLUDED
            //marginRateByOrder[op.orderId] ? '' : marginRateByOrder[op.orderId] = {officeMargin:0,sales:deliveryCharge,marginRate:0,netvisorId:o.netvisorId}
            marginRateByOrder[op.orderId].officeMargin += (confirmedMargin + deliveryMarginByProduct)
            marginRateByOrder[op.orderId].sales += total
            marginRateByOrder[op.orderId].marginRate = (marginRateByOrder[op.orderId].sales/(marginRateByOrder[op.orderId].sales-marginRateByOrder[op.orderId].officeMargin))
            marginRateByOrder[op.orderId].marginRate = marginRateByOrder[op.orderId].marginRate.toFixed(2)
            marginRateByOrder[op.orderId].marginRate = Number(marginRateByOrder[op.orderId].marginRate)
        }


        for (const key of Object.keys(orderedProducts)) {
          op = orderedProducts[key]
          o = this.orders[op.orderId]
          if(o === undefined){ console.log("GENERATING ORDERED PRODUCTS: ORDER NOT FOUND FOR ORDER ID: "+ op.orderId +" VIA OP ID: " + op.id); continue} 
          if(this.companies[this.orders[op.orderId].companyId] === undefined) {console.log("GENERATING ORDERED PRODUCTS: COMPANY NOT FOUND ID: " + this.orders[op.orderId].companyId + " ORDERD ID: " +op.orderId); continue}
          if(!op.orderInvoiceStatus || op.orderInvoiceStatus !== 'invoiced') continue
          if(!op.whenToInvoice) continue
          var createdMonth = o.created_at.toDate().getMonth() +1
          var createdYear = o.created_at.toDate().getFullYear()
          
          //if(createdYear <= 2024 && createdMonth > 7) console.log({createdYear,createdMonth})
          if(createdYear < 2024  || (createdYear == 2024 && createdMonth < 8)) continue
          if(o.netvisorId === '11421') console.log({createdYear,createdMonth})
          
          
          pv = this.productVariations[op.productVariationId] !== undefined ? this.productVariations[op.productVariationId] : {}
          
          
          opsData[op.id] = {}
          Object.defineProperty(opsData, op.id, { configurable: false });
          
          opsData[op.id].deliveryMarginPerProduct = 0
          if(deliveryMarginsByOrder[op.orderId]) opsData[op.id].deliveryMarginPerProduct = deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct

          opsData[op.id].id = op.id
          opsData[op.id].productId = op.productId
          opsData[op.id].orderId = op.orderId
          opsData[op.id].orderInvoiceStatus = op.orderInvoiceStatus ? op.orderInvoiceStatus : ''
          opsData[op.id].deliveryStatus = op.orderStatus 
          
          
          if (o.created_at !== undefined && o.created_at.seconds !== undefined){
            opsData[op.id].created_at = o.created_at
          }
          else if (o.created_at !== undefined && o.created_at.seconds === undefined) {
            var seconds = new Date(o.created_at).getTime()/1000
            opsData[op.id].created_at = {seconds}
          }
          else opsData[op.id].created_at = ""

          if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds !== undefined){
            opsData[op.id].whenToInvoice = op.whenToInvoice
          }
          else if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds === undefined) {
            var seconds = new Date(op.whenToInvoice).getTime()/1000
            opsData[op.id].whenToInvoice = {seconds}
          }

          var invoicedMonth = opsData[op.id].whenToInvoice.toDate().getMonth() +1
          var invoicedYear = opsData[op.id].whenToInvoice.toDate().getFullYear()
          yearMonthOptionsForInvoiced[invoicedYear] === undefined ? yearMonthOptionsForInvoiced[invoicedYear] = {} : ''
          yearMonthOptionsForInvoiced[invoicedYear][invoicedMonth] === undefined ? yearMonthOptionsForInvoiced[invoicedYear][invoicedMonth] = true : ''



          var total = 0
          try{
            total = Number(op.printQuantity)*Number(op.unitPrintPrice) 
              + Number(op.quantity)*Number(op.unitPrice) 
              + Number(op.numberOfPositionings)*Number(op.pricePerPositioning) 
            //total = total.toFixed(2)
            if(isNaN(total) ) total = 0
            else total = total.toFixed(2)
            opsData[op.id].total = Number(total).toFixed(2)
          }
          catch(e){
            opsData[op.id].total = total
          }


          
          opsData[op.id].marginRate = marginRateByOrder[op.orderId] ? marginRateByOrder[op.orderId].marginRate : 0
          opsData[op.id].id = op.id
          opsData[op.id].deliveryCharge = this.orders[op.orderId].deliveryCharge
          opsData[op.id].billingReferenceDetails = this.orders[op.orderId].billingReferenceDetails !== undefined ? this.orders[op.orderId].billingReferenceDetails : ''
          
          opsData[op.id].orderSummary === undefined ? opsData[op.id].orderSummary = '' : ''
          opsData[op.id].orderSummary += this.products[op.productId] !== undefined ? this.products[op.productId].name.fi : ''
          if(pv && pv.colorCode){
            var colorName = ""
            if(this.settings.colors[pv.colorCode]) colorName = this.settings.colors[pv.colorCode].fi
            opsData[op.id].orderSummary += '-'+colorName
          }
          if(pv.size && pv.size.trim() !== ""){opsData[op.id].orderSummary += '-'+pv.size} 
          opsData[op.id].orderSummary += ' x ' + op.quantity + ';'
          opsData[op.id].orderSummaryIds === undefined ? opsData[op.id].orderSummaryIds = '' : ''
          var avecorSku = this.products[pv.productId] && this.products[pv.productId].avecorSku ? this.products[pv.productId].avecorSku : ''

          opsData[op.id].orderSummaryIds += avecorSku + '-' + pv.colorCode ? pv.colorCode : ''
          opsData[op.id].orderSummaryIds += pv.wholesaleSku ? pv.wholesaleSku + ' ' : ''
          //opsData[op.id].orderSummary = this.orders[op.orderId].orderSummary
          //opsData[op.id].orderSummaryIds = this.orders[op.orderId].orderSummaryIds
          opsData[op.id].salespersonMargin = op.salespersonMargin ? op.salespersonMargin : 0
          opsData[op.id].confirmedMargin = Number(op.confirmedMargin)

          opsData[op.id].orderResponsible = this.orders[op.orderId].orderResponsible
          
          opsData[op.id].netvisorId = this.orders[op.orderId].netvisorId ? this.orders[op.orderId].netvisorId :''
          opsData[op.id].netvisorKey = this.orders[op.orderId].netvisorKey ? this.orders[op.orderId].netvisorKey : ''
          opsData[op.id].netvisorId_test_env = this.orders[op.orderId].netvisorId_test_env ? this.orders[op.orderId].netvisorId_test_env : ''
          opsData[op.id].netvisorKey_test_env = this.orders[op.orderId].netvisorKey_test_env ? this.orders[op.orderId].netvisorKey_test_env : ''
          opsData[op.id].companyId = this.orders[op.orderId].companyId
          opsData[op.id].deliveryWeek = this.orders[op.orderId].deliveryWeek ? this.orders[op.orderId].deliveryWeek : ''
          opsData[op.id].pending = this.orders[op.orderId].pending !== undefined ? this.orders[op.orderId].pending : false
          opsData[op.id].avecorOrder = this.orders[op.orderId].avecorOrder !== undefined ? this.orders[op.orderId].avecorOrder : false
          opsData[op.id].shopifyOrder = this.orders[op.orderId].shopifyOrder !== undefined ? this.orders[op.orderId].shopifyOrder : false
          opsData[op.id].deadline = this.orders[op.orderId].deadline !== undefined ? this.orders[op.orderId].deadline : false
          opsData[op.id].sample = this.orders[op.orderId].sample !== undefined ? this.orders[op.orderId].sample : false
          opsData[op.id].salespersonSample = this.orders[op.orderId].salespersonSample !== undefined ? this.orders[op.orderId].salespersonSample : false
          opsData[op.id].reclaimed = this.orders[op.orderId].reclaimed !== undefined ? this.orders[op.orderId].reclaimed : false
          opsData[op.id].companyName = this.companies[this.orders[op.orderId].companyId] !== undefined ? this.companies[this.orders[op.orderId].companyId].companyName : ""
          opsData[op.id].totalOrders = this.companies[this.orders[op.orderId].companyId] !== undefined ? this.companies[this.orders[op.orderId].companyId].totalOrders : 1
          opsData[op.id].invoicesPaidDate = this.orders[op.orderId].invoicesPaidDate ? this.orders[op.orderId].invoicesPaidDate : null
          
          try{
            var company = this.companies[this.orders[op.orderId].companyId]
            opsData[op.id].companyAddress = company.deliveryAddress + " " + company.deliveryPostalCode + ", " + company.deliveryCity + " " + company.deliveryCountry
          } catch(e){ 
            opsData[op.id].companyAddress = ""
          }

          opsData[op.id].contactName = this.contacts[this.orders[op.orderId].contactId].firstName + " " + this.contacts[this.orders[op.orderId].contactId].lastName
          opsData[op.id].contactId = this.orders[op.orderId].contactId
          opsData[op.id].contactEmail = this.contacts[this.orders[op.orderId].contactId].email
          opsData[op.id].contactPhone = this.contacts[this.orders[op.orderId].contactId].phone
          opsData[op.id].salespersonId = this.orders[op.orderId].originalSalesperson ? this.orders[op.orderId].originalSalesperson : this.orders[op.orderId].salesperson
          !this.staff[this.orders[op.orderId].salesperson] ? console.log(this.orders[op.orderId]) : ''
          opsData[op.id].salespersonFirstName = this.staff[opsData[op.id].salespersonId].firstName
          
          opsData[op.id].orderAndInvoiceStatuses =""
          op.orderStatus !== undefined && op.orderInvoiceStatus !== undefined ? opsData[op.id].orderAndInvoiceStatuses = op.orderStatus+'_'+op.orderInvoiceStatus : ''
          opsData[op.id].archived = op.archived ? true : false
          
        }
        
        var sortedOrderedProducts = Object.keys(opsData).sort(function(a,b){
          var aDate = opsData[a].whenToInvoice.seconds
          var bDate = opsData[b].whenToInvoice.seconds
          return bDate - aDate;
        });
        var newOpsData = {}
        sortedOrderedProducts.map(function(key, index) {
          newOpsData[key] = opsData[key]
          return 
        })
        this.yearMonthOptionsForInvoiced = yearMonthOptionsForInvoiced
        this.opsData = newOpsData 
      },
      
      getOrderProducts(orderId){
        return typeof this.orderStatuses[orderId] !== "undefined" ? this.orderStatuses[orderId] : []
      },
      
      getMarginRateColor(order){
        if(typeof order.salespersonMargin !== "undefined" && order.salespersonMargin) {
          var total = this.getTotal(order.id)
          var marginRate = (total/(total-order.salespersonMargin)).toFixed(2)
          if (marginRate < 2) return "#DE3164"
          else if (marginRate >= 2 && marginRate <= 2.5) return "#FFBF00"
          else if(marginRate > 2.5) return "#2ECC40"
        } 
        else return "#ccc"
      },
      setDeliveryStatusColor(status){
        if(status === "new") return ""
      },
      fieldUpdated(field, orderId){
        console.log(this.orders[orderId][field])
        this.orders[orderId][field] = this.orders[orderId][field].replace(",", ".")
      },
      generateAddress(companyId){
        var company = this.companies[companyId]
        var address = company.deliveryAddress + " " + company.deliveryPostalCode + ", " + company.deliveryCity + " " + company.deliveryCountry
        return address
      },
      getContacts(companyId){
        var contacts = this.contacts
        var contactList = []
        Object.keys(this.contacts).map(function(key, index) {
          var c = contacts[key]
          c.companyId === companyId ? contactList.push({text: c.firstName + " " + c.lastName, value: c.id}) : ""
          return {text: c.firstName + " " + c.lastName, value: c.id}
        })
        return contactList
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        return ''
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      getProductsTotal(orderId) {
        var orderedProducts = this.orderedProducts
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.unitPrice * p.quantity) 
          }
          return result
        },0))).toFixed(2)
      },
      getPrintTotal(orderId) {
        var orderedProducts = this.orderedProducts
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.unitPrintPrice * p.printQuantity) 
          }
          return result
        },0))).toFixed(2)
      },
      getPositioningTotal(orderId) {
        var orderedProducts = this.orderedProducts
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.pricePerPositioning * p.numberOfPositionings) 
          }
          return result
        },0))).toFixed(2)
      },
      getTotal(orderId) {
        return Number(this.getProductsTotal(orderId)) + Number(this.getPrintTotal(orderId)) + Number(this.getPositioningTotal(orderId)) + Number(this.orders[orderId].deliveryCharge)
      },
      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.newItem = Object.assign({}, item)
        this.dialog = true
      },
      
      close () {
        this.dialog = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      inlineSaveField(orderId,field,value){
        if (field === "salespersonMargin") value = value.replace(",", ".")
        if (field === "officeMargin") value = value.replace(",", ".")
        if (field === "salespersonMargin") {
          if(this.orders[orderId].officeMargin){
            this.$store.dispatch('order/set', {
              id:orderId,
              [field]:value,
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  
          }
          else {
            this.$store.dispatch('order/set', {
              id:orderId,
              [field]:value,
              officeMargin:value
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else {
          this.$store.dispatch('order/set', {
            id:orderId,
            [field]:value
          })
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      inlineSaveOrderedProductField(opId, field,value){
        if (field === "confirmedMargin") value = value.replace(",", ".")
        if (field === "salespersonMargin") value = value.replace(",", ".")
        
        console.log({opId,field,value})
        this.$store.dispatch('orderedProduct/set', {
          id:opId,
          [field]:value
        })
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/blocks/MarginsOrdersTable.vue